import { render } from "./TheCreditReturnsBlocker.vue?vue&type=template&id=07e2a1de&scoped=true"
const script = {}

import "./TheCreditReturnsBlocker.vue?vue&type=style&index=0&id=07e2a1de&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-07e2a1de"]])

export default __exports__